export default __webpack_public_path__ + "static/media/result-success.dd33b909.svg";